import dayjs from 'dayjs';

export function isFutureMonthYear(month, year) {
  if (!month || !year) return false;

  const value = dayjs(new Date(year, month - 1, 1));
  const now = dayjs().startOf('month');

  return value.isAfter(now);
}

export function isEndAfterStart({ startMonth, startYear, endMonth, endYear }) {
  const sm = Number(startMonth);
  const sy = Number(startYear);
  const em = Number(endMonth);
  const ey = Number(endYear);

  if (!sm || !sy || !em || !ey) return true;

  if (ey > sy) return true;

  if (ey === sy && em > sm) return true;

  return false;
}

export function shouldValidateEndDate({ isCurrent, startMonth, startYear, endMonth, endYear }) {
  return isCurrent !== true && !!startMonth && !!startYear && !!endMonth && !!endYear;
}

export function formatExperienceDuration({ startMonth, startYear, endMonth, endYear, isCurrent }) {
  if (!startMonth || !startYear) return '';

  const start = dayjs(new Date(startYear, startMonth - 1, 1));
  const end = isCurrent ? dayjs() : dayjs(new Date(endYear, endMonth - 1, 1));

  if (!end.isValid() || end.isBefore(start)) return '';

  const totalMonths = end.diff(start, 'month');

  if (totalMonths <= 0) return 'Less than a month';

  const years = Math.floor(totalMonths / 12);
  const months = totalMonths % 12;

  return [
    years && `${years} year${years > 1 ? 's' : ''}`,
    months && `${months} month${months > 1 ? 's' : ''}`,
  ]
    .filter(Boolean)
    .join(' ');
}
